import { useState, useEffect } from "react";
import { useRepairBlockRecurringLinksQuery } from "../../react-query/block/queries";

// TEMP: 임시 반복 수정 로직을 위한 훅
// TODO: 반복 수정 로직이 더 이상 필요없을 때 이 파일 삭제
export function useRepairRecurringLinks(hasBlocksSynchronizedWithGoogle: boolean) {
  const [shouldRepair, setShouldRepair] = useState(false);

  type Timeout = ReturnType<typeof setTimeout>;
  useEffect(() => {
    let timeoutId: Timeout;

    if (hasBlocksSynchronizedWithGoogle) {
      timeoutId = setTimeout(() => {
        setShouldRepair(true);
      }, 3000);
    }

    return () => {
      if (timeoutId) {
        clearTimeout(timeoutId);
      }
    };
  }, [hasBlocksSynchronizedWithGoogle]);

  useRepairBlockRecurringLinksQuery({
    enabled: shouldRepair,
  });
}
